// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-35XkP","inner":"inner-37mCL","title":"title-3n-h1","checked":"checked-3yVuJ","active":"active-1ea92","segment":"segment-3poTD"};